import Admission from "./pages/Admission";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/HomePage";
import About from "./pages/About";
import Mission from "./pages/Mission";
import Team from "./pages/team";
import Terms from "./pages/policy";
import InfoTech from "./pages/InformationTechnology";
import ComputerHardware from "./components/Courses/InformationTechnology/ITPrograms/ComputerHardware";
import ComputerSoftware from "./components/Courses/InformationTechnology/ITPrograms/ComputerSoftware";
import ComputerApplications from "./components/Courses/InformationTechnology/ITPrograms/ComputerApplications";
import NetworkingSystemAdmin from "./components/Courses/InformationTechnology/ITPrograms/NetworkSystem";
import LinuxAdministration from "./components/Courses/InformationTechnology/ITPrograms/LinuxAdministration";
import DatabaseManagement from "./components/Courses/InformationTechnology/ITPrograms/DatabaseManagement";
import ObjectOrientedProgramming from "./components/Courses/InformationTechnology/ITPrograms/ObjectOrientedProgramming";
import WebAppDevelopment from "./components/Courses/InformationTechnology/ITPrograms/WebAppDevelopment";
import CyberSecurity from "./components/Courses/InformationTechnology/ITPrograms/CyberSecurity";
import CloudComputing from "./components/Courses/InformationTechnology/ITPrograms/CloudComputing";
import SystemAnalysisDesign from "./components/Courses/InformationTechnology/ITPrograms/SystemAnalysisDesign";
import AdobeApplication from "./components/Courses/InformationTechnology/ITPrograms/AdobeApps";
import CyberSec from "./pages/CyberSecurity";
import CybersecurityIntro from "./components/Courses/CyberSecurity/CyberPrograms/CybersecurityIntro";
import NetworkOS from "./components/Courses/CyberSecurity/CyberPrograms/NetworkOS";
import CryptographyBasics from "./components/Courses/CyberSecurity/CyberPrograms/cryptography";
import EthicalHackingPenTesting from "./components/Courses/CyberSecurity/CyberPrograms/EthicalTesting";
import WebApplicationSecurity from "./components/Courses/CyberSecurity/CyberPrograms/WebSecurity";
import MalwareForensics from "./components/Courses/CyberSecurity/CyberPrograms/MalwareForensics";
import WirelessMobileSecurity from "./components/Courses/CyberSecurity/CyberPrograms/WirelessSecurity";
import ComputerScience from "./pages/ComputerScience";
import ComputerEngineering from "./pages/ComputerEngineering";
import ElectronicsTelecommunications from "./pages/ElectronicsTelecommunications";
import BusinessAdministration from "./pages/BusinessAdministration";
import Accountancy from "./pages/Accountancy";
import TravelTourismManagement from "./pages/TravelTourismManagement";
import ShortCourses from "./pages/ShortCourses";
import PhotoGallery from "./pages/PhotoGallery";
import VideoGallery from "./pages/VideoGallery";
import AllEvents from "./pages/AllEvents";
import EventDetail from "./pages/EventDetail";
import AllNews from "./pages/AllNews";
import Apply from "./pages/Apply";
import StudentPortal from "./pages/StudentPortal";
import NotFound from "./pages/NotFound";
import NewsDetail from "./pages/NewsDetail";
import ContactUs from "./pages/ContactUs";
import FeeStructure from "./pages/FeeStructure";
import Athletics from "./pages/Athletics";
import CampusTour from "./pages/CampusTour";
import Academics from "./pages/Academics";
import Departments from "./pages/Departments";
import Programs from "./pages/Programs";
import Library from "./pages/Library";
import Services from "./pages/Services";
import Feedback from "./pages/Feedback";
import ProfessionalCourses from "./pages/ProfessionalCourses";
import ProgrammingFundamentals from "./pages/ProgrammingFundamentals";
import DataStructuresAlgorithms from "./pages/DataStructuresAlgorithms";
import DigitalElectronics from "./pages/DigitalElectronics";
import ComputerArchitecture from "./pages/ComputerArchitecture";
import AdDemo from "./pages/AdDemo";
//import Blog from "./pages/Blog";

// Scroll to top on route change
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/mission" element={<Mission />} />
        <Route path="/about/trustees" element={<Team />} />
        <Route path="/about/terms-conditions" element={<Terms />} />
        <Route path="/course/information-technology" element={<InfoTech />} />
        <Route path="/course/cyber-security" element={<CyberSec />} />
        <Route path="/course/computer-science" element={<ComputerScience />} />
        <Route
          path="/course/computer-engineering"
          element={<ComputerEngineering />}
        />
        <Route
          path="/course/electronics-telecommunications"
          element={<ElectronicsTelecommunications />}
        />
        <Route
          path="/course/business-administration"
          element={<BusinessAdministration />}
        />
        <Route path="/course/accountancy" element={<Accountancy />} />
        <Route
          path="/course/travel-tourism-management"
          element={<TravelTourismManagement />}
        />
        <Route path="/course/short-courses" element={<ShortCourses />} />
        <Route
          path="/course/professional-courses"
          element={<ProfessionalCourses />}
        />
        <Route path="/gallery/photos" element={<PhotoGallery />} />
        <Route path="/gallery/videos" element={<VideoGallery />} />
        <Route path="/events" element={<AllEvents />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/news" element={<AllNews />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/student-portal" element={<StudentPortal />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/fees" element={<FeeStructure />} />
        <Route path="/athletics" element={<Athletics />} />
        <Route path="/campus-tour" element={<CampusTour />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/library" element={<Library />} />
        <Route path="/services" element={<Services />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/admissions" element={<Admission />} />
        <Route path="/ad-demo" element={<AdDemo />} />
        {/*        <Route path="/blog" element={<Blog />} />*/}

        <Route
          path="/courses/information-technology/computer-hardware"
          element={<ComputerHardware />}
        />
        <Route
          path="/courses/information-technology/computer-software"
          element={<ComputerSoftware />}
        />
        <Route
          path="/courses/information-technology/computer-applications"
          element={<ComputerApplications />}
        />

        <Route
          path="/courses/information-technology/networking-system-administration"
          element={<NetworkingSystemAdmin />}
        />
        <Route
          path="/courses/information-technology/linux-administration"
          element={<LinuxAdministration />}
        />
        <Route
          path="/courses/information-technology/database-management"
          element={<DatabaseManagement />}
        />
        <Route
          path="/courses/information-technology/object-oriented-programming-oop"
          element={<ObjectOrientedProgramming />}
        />
        <Route
          path="/courses/information-technology/website-application-development"
          element={<WebAppDevelopment />}
        />
        <Route
          path="/courses/information-technology/cyber-security"
          element={<CyberSecurity />}
        />
        <Route
          path="/courses/information-technology/cloud-computing"
          element={<CloudComputing />}
        />
        <Route
          path="/courses/information-technology/system-analysis-design"
          element={<SystemAnalysisDesign />}
        />
        <Route
          path="/courses/information-technology/adobe-applications"
          element={<AdobeApplication />}
        />

        {/* Cyber Security Program Links */}
        <Route
          path="/courses/cyber-security/intro-to-cyber-security"
          element={<CybersecurityIntro />}
        />
        <Route
          path="/courses/cyber-security/network-os-security"
          element={<NetworkOS />}
        />
        <Route
          path="/courses/cyber-security/cryptography-basics"
          element={<CryptographyBasics />}
        />
        <Route
          path="/courses/cyber-security/ethical-hacking-pen-testing"
          element={<EthicalHackingPenTesting />}
        />
        <Route
          path="/courses/cyber-security/web-application-security"
          element={<WebApplicationSecurity />}
        />
        <Route
          path="/courses/cyber-security/malware-forensics"
          element={<MalwareForensics />}
        />
        <Route
          path="/courses/cyber-security/wireless-mobile-security"
          element={<WirelessMobileSecurity />}
        />

        {/* Computer Science Program Links */}
        <Route
          path="/courses/computer-science/programming-fundamentals"
          element={<ProgrammingFundamentals />}
        />
        <Route
          path="/courses/computer-science/data-structures-algorithms"
          element={<DataStructuresAlgorithms />}
        />

        {/* Computer Engineering Program Links */}
        <Route
          path="/courses/computer-engineering/digital-electronics"
          element={<DigitalElectronics />}
        />
        <Route
          path="/courses/computer-engineering/computer-architecture"
          element={<ComputerArchitecture />}
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
export default App;
